import type * as THREE from 'three';
import type { ChamferFeaturePrototype } from '../../../feature/prototype/chamfer/ChamferFeaturePrototype';
import { FeatureResultObject } from '../FeatureResultObject';

/**
 * 倒角结果体对象。
 */
export class ChamferResultObject extends FeatureResultObject<ChamferFeaturePrototype> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: ChamferFeaturePrototype;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
